import { render, staticRenderFns } from "./ProcessInformation.vue?vue&type=template&id=10da919c&scoped=true"
import script from "./ProcessInformation.vue?vue&type=script&lang=js"
export * from "./ProcessInformation.vue?vue&type=script&lang=js"
import style0 from "./ProcessInformation.vue?vue&type=style&index=0&id=10da919c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10da919c",
  null
  
)

export default component.exports